import { render, staticRenderFns } from "./CollectionUploader.vue?vue&type=template&id=6d6ea38b"
import script from "./CollectionUploader.vue?vue&type=script&lang=js"
export * from "./CollectionUploader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports